import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Clients } from 'src/app/models/interfaces/clients';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Facility } from '../../../interfaces/facility';
import { Devices } from '../../../interfaces/devices';

@Component({
  selector: 'app-add-devices',
  templateUrl: './add-devices.component.html',
  styleUrls: ['./add-devices.component.css']
})
export class AddDevicesComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }
  ngOnInit(): void {
    this.getData();
    if (this.data != null) {
      this.primaryForm.patchValue(this.data);
    }
  }
  /**
   * Hago referencia a la ventana actual
   */
  @Input()
  modalRef: NgbModalRef | undefined;

  @Input()
  data: any=null;
  @Output()
  success = new EventEmitter<boolean>();
  @Output()
  record = new EventEmitter<Devices>();
  
  facilityes:Facility[];


  primaryForm = new UntypedFormGroup({
    identification: new UntypedFormControl(),
    serie: new UntypedFormControl(),
    facility_id: new UntypedFormControl(0),
    place: new UntypedFormControl(''),
  });

  create() {
    this.api.createDevices(this.primaryForm).subscribe(
      (response) => {
        this.toast.success('Dispositivo creada correctamente', 'Gestión Dispositivos');
        this.record.emit(response.data as Devices);
        this.success.emit(true);
        if (this.modalRef != null) {
          this.modalRef.close();
        } else {
          this.modal.dismissAll();
        }

      },
      (error) => {
        this.toast.warning(error.error.mistakes, 'Tenemos un error');
      }
    );
  }
  getData() {
    this.api.getAllFacility().subscribe(
      (response) => {
        this.facilityes = response.data as Facility[];
      }
    );
  }
  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
}
